/* 🤖 this file was generated by svg-to-ts*/
export const iconStarCircled = {
  name: 'star_circled',
  data: `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_b_364_1420)">
  <circle cx="13.8926" cy="13.8926" r="13.8926" fill="white" fill-opacity="0.2"/>
  </g>
  <path d="M14.0576 18.2794L17.695 20.4279C18.3611 20.8216 19.1763 20.2395 19.001 19.5034L18.0368 15.4633L21.2535 12.7413C21.8408 12.2448 21.5252 11.3033 20.7539 11.2434L16.5205 10.8924L14.864 7.07481C14.566 6.38148 13.5493 6.38148 13.2513 7.07481L11.5947 10.8839L7.36131 11.2348C6.59001 11.2947 6.27448 12.2363 6.86172 12.7327L10.0784 15.4547L9.11427 19.4949C8.93898 20.231 9.7541 20.813 10.4202 20.4193L14.0576 18.2794Z" fill="#FFDD64"/>
  <defs>
  <filter id="filter0_b_364_1420" x="-6" y="-6" width="39.7852" height="39.7852" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feGaussianBlur in="BackgroundImage" stdDeviation="3"/>
  <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_364_1420"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_364_1420" result="shape"/>
  </filter>
  </defs>
  </svg>`,
}
